module.exports = __webpack_public_path__ + "img/green.ca01db25.png";